var _classCallCheck = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Generated by CoffeeScript 2.4.1
(function () {
  var NodeType, XMLCharacterData, XMLProcessingInstruction;
  NodeType = require('./NodeType');
  XMLCharacterData = require('./XMLCharacterData');

  // Represents a processing instruction
  module.exports = XMLProcessingInstruction = /*#__PURE__*/function (_XMLCharacterData) {
    "use strict";

    _inherits(XMLProcessingInstruction, _XMLCharacterData);
    var _super = _createSuper(XMLProcessingInstruction);
    // Initializes a new instance of `XMLProcessingInstruction`

    // `parent` the parent node
    // `target` instruction target
    // `value` instruction value
    function XMLProcessingInstruction(parent, target, value) {
      var _this;
      _classCallCheck(this, XMLProcessingInstruction);
      _this = _super.call(this, parent);
      if (target == null) {
        throw new Error("Missing instruction target. " + _this.debugInfo());
      }
      _this.type = NodeType.ProcessingInstruction;
      _this.target = _this.stringify.insTarget(target);
      _this.name = _this.target;
      if (value) {
        _this.value = _this.stringify.insValue(value);
      }
      return _this;
    }

    // Creates and returns a deep clone of `this`
    _createClass(XMLProcessingInstruction, [{
      key: "clone",
      value: function clone() {
        return Object.create(this);
      }

      // Converts the XML fragment to string

      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
    }, {
      key: "toString",
      value: function toString(options) {
        return this.options.writer.processingInstruction(this, this.options.writer.filterOptions(options));
      }
    }, {
      key: "isEqualNode",
      value: function isEqualNode(node) {
        if (!_get(_getPrototypeOf(XMLProcessingInstruction.prototype), "isEqualNode", this).call(this, node)) {
          return false;
        }
        if (node.target !== this.target) {
          return false;
        }
        return true;
      }
    }]);
    return XMLProcessingInstruction;
  }(XMLCharacterData);
}).call(this);